import * as types from "../actions/types/salesMode.types";

const initialState = {
    loginStatus: "idle",
    userData: null,
    loginMessage: "",
};

export const SalesModeReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SALES_MODE_LOGIN_STARTED:
            return {
                ...state,
                loginStatus: "loading",
            };
        case types.SALES_MODE_LOGIN_SUCCEEDED:
            return {
                ...state,
                loginStatus: "success",
                userData: action.payload,
            };
        case types.SALES_MODE_LOGIN_FAILED:
            return {
                ...state,
                loginStatus: "failed",
                loginMessage: action.payload,
            };

        default:
            return state;
    }
};
